import { getInstance } from './index';
import store from '@/store';
import { getI18nLanguage } from '@/i18n';
import config from '@/config/client';
import { NavigationGuard } from 'vue-router';

const redirectUserToProfile = () => {
  // Redirect user to profiling
  const url = window.location;
  const redirectTo = `${url.protocol}//${url.host}${url.pathname}`;
  window.location.href = `${config.acoHost}/profiling?redirect_to=${encodeURIComponent(redirectTo)}`;
};

// eslint-disable-next-line consistent-return
export const authGuard: NavigationGuard = (to, _from, next) => {
  const authService = getInstance();

  const handler = async () => {
    if (authService.targetUrl) {
      // Redirect user to path active before authentication
      const targetUrl = authService.targetUrl;
      authService.targetUrl = null;

      return next({ path: targetUrl, replace: true });
    }

    // If the user is authenticated, continue with the route
    if (authService.isAuthenticated) {
      store.dispatch('user/setAuth0Data', authService.user);

      if (!authService.user['https://my.atlasti.com/schema/has_profile']) {
        redirectUserToProfile();

        return false;
      }

      const result = await store.dispatch('user/authenticate', {
        email: authService.user.email,
        firstname: authService.user.given_name,
        lastname: authService.user.family_name,
        mayReceiveEmails: Boolean(authService.user['https://my.atlasti.com/schema/newsletter_permission']),
        locale: getI18nLanguage(),
      });

      if (result?.user) {
        store.dispatch('user/login', result.user);

        return next();
      }

      return false;
    }

    // Otherwise, log in
    authService.loginWithRedirect({
      appState: {
        targetUrl: to.fullPath,
        inviteToken: store.state.user.inviteToken,
      },
    });

    return false;
  };

  // If loading has already finished, check our auth state using  handler()`
  if (!authService.loading) {
    return handler();
  }

  return new Promise((resolve) => {
    authService.onLoaded(() => resolve(handler()));
  });
};
